import React, { useState } from "react";
import Layout from "../components/layouts/Layout";

const TechnologyPatentsPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const patents = [
    {
      id: 1,
      title: "量子リザバコンピューティングによる時系列予測システム",
      patentNumber: "特許第7123456号",
      status: "登録済",
      applicationDate: "2023年3月15日",
      registrationDate: "2024年1月20日",
      inventors: ["田中太郎", "佐藤花子", "山田次郎"],
      abstract: "量子もつれを利用したリザバコンピューティングアーキテクチャにより、従来手法と比較して10倍以上の高速学習を実現する時系列予測システム。量子ビットの状態空間を活用することで、複雑な非線形パターンの認識精度を大幅に向上させる。",
      category: "quantum",
      claims: 15,
      priority: "高"
    },
    {
      id: 2,
      title: "量子ノイズ耐性リザバーネットワーク",
      patentNumber: "特許出願2024-012345",
      status: "審査中",
      applicationDate: "2024年2月10日",
      registrationDate: "審査中",
      inventors: ["鈴木一郎", "田中太郎"],
      abstract: "量子デコヒーレンスによるノイズを逆に利用して、従来のリザバーネットワークでは実現できない高精度な情報処理を可能にする革新的アーキテクチャ。特に音声認識と画像処理において優れた性能を発揮する。",
      category: "quantum",
      claims: 12,
      priority: "高"
    },
    {
      id: 3,
      title: "量子アニーリングを用いた最適化問題解決手法",
      patentNumber: "PCT/JP2024/001234",
      status: "国際出願中",
      applicationDate: "2024年1月5日",
      registrationDate: "審査中",
      inventors: ["高橋三郎", "佐藤花子"],
      abstract: "量子アニーリングとリザバコンピューティングを組み合わせた新しい最適化アルゴリズム。組み合わせ最適化問題において、従来のシミュレーテッドアニーリングと比較して100倍の高速化を実現。",
      category: "optimization",
      claims: 18,
      priority: "中"
    }
  ];

  const papers = [
    {
      id: 1,
      title: "Quantum Reservoir Computing for High-Speed Time Series Prediction",
      journal: "Nature Quantum Information",
      year: "2024",
      authors: ["T. Tanaka", "H. Sato", "J. Yamada"],
      doi: "10.1038/s41534-024-00XXX-X",
      citations: 127,
      abstract: "We demonstrate a novel quantum reservoir computing architecture that achieves 10x faster learning compared to classical methods. Our approach leverages quantum entanglement to create high-dimensional reservoir states, enabling superior performance in time series prediction tasks.",
      category: "quantum",
      impactFactor: "5.737",
      openAccess: true
    },
    {
      id: 2,
      title: "Noise-Resilient Quantum Computing with Reservoir Networks",
      journal: "Physical Review Applied",
      year: "2024",
      authors: ["I. Suzuki", "T. Tanaka", "K. Watanabe"],
      doi: "10.1103/PhysRevApplied.21.XXXX",
      citations: 89,
      abstract: "We present a quantum reservoir computing framework that exploits quantum noise to enhance computational performance. This counterintuitive approach demonstrates improved accuracy in pattern recognition tasks compared to noiseless quantum systems.",
      category: "quantum",
      impactFactor: "4.808",
      openAccess: false
    },
    {
      id: 3,
      title: "Scalable Quantum Annealing with Reservoir Computing",
      journal: "Science Advances",
      year: "2023",
      authors: ["S. Takahashi", "H. Sato", "M. Kobayashi"],
      doi: "10.1126/sciadv.XXXX",
      citations: 156,
      abstract: "A hybrid quantum-classical algorithm combining quantum annealing with reservoir computing shows unprecedented scaling for combinatorial optimization problems. We demonstrate 100x speedup over simulated annealing on large-scale instances.",
      category: "optimization",
      impactFactor: "14.957",
      openAccess: true
    },
    {
      id: 4,
      title: "量子リザバコンピューティングの理論的基礎",
      journal: "日本物理学会誌",
      year: "2023",
      authors: ["田中太郎", "佐藤花子"],
      doi: "10.11316/jpsgaiyo.78.2.XXX",
      citations: 45,
      abstract: "量子リザバコンピューティングの理論的枠組みを体系化し、古典的手法との比較において優位性を示す数学的証明を提供。特に、量子もつれによる計算能力の向上メカニズムを明らかにした。",
      category: "theory",
      impactFactor: "1.234",
      openAccess: true
    }
  ];

  const categories = [
    { id: 'all', name: '全カテゴリ' },
    { id: 'quantum', name: '量子コンピューティング' },
    { id: 'optimization', name: '最適化' },
    { id: 'theory', name: '理論' }
  ];

  const filteredPatents = selectedCategory === 'all' 
    ? patents 
    : patents.filter(p => p.category === selectedCategory);

  const filteredPapers = selectedCategory === 'all' 
    ? papers 
    : papers.filter(p => p.category === selectedCategory);

  return (
    <Layout 
      title="特許・論文情報" 
      subtitle="QRC技術に関する知的財産と研究成果をご紹介します"
    >
      {/*  */}
      <section style={{ 
        padding: '120px 0 80px',
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #3b82f6 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-10 col-md-offset-1">
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '20px', marginBottom: '40px' }}>
                量子リザバコンピューティング（QRC）技術の<br />
                知的財産権と最新研究成果
              </p>
              
              {/* 統計情報 */}
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                gap: '40px', 
                flexWrap: 'wrap',
                marginTop: '40px'
              }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '36px', fontWeight: '700', color: 'white' }}>15+</div>
                  <div style={{ color: 'rgba(255, 255, 255, 0.8)' }}>特許出願</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '36px', fontWeight: '700', color: 'white' }}>8</div>
                  <div style={{ color: 'rgba(255, 255, 255, 0.8)' }}>査読論文</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '36px', fontWeight: '700', color: 'white' }}>400+</div>
                  <div style={{ color: 'rgba(255, 255, 255, 0.8)' }}>総引用数</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* フィルター */}
      <section style={{ padding: '60px 0 40px', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                <h3 style={{ color: '#f1f5f9', marginBottom: '20px' }}>カテゴリ別表示</h3>
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px' }}>
                  {categories.map((category) => (
                    <button
                      key={category.id}
                      onClick={() => setSelectedCategory(category.id)}
                      style={{
                        padding: '8px 20px',
                        borderRadius: '25px',
                        border: '1px solid rgba(59, 130, 246, 0.3)',
                        background: selectedCategory === category.id ? '#3b82f6' : 'transparent',
                        color: selectedCategory === category.id ? 'white' : '#cbd5e1',
                        cursor: 'pointer',
                        transition: 'all 0.3s'
                      }}
                    >
                      {category.name}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 特許一覧 */}
      <section style={{ padding: '60px 0', backgroundColor: '#1e293b' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 style={{ 
                color: '#f1f5f9', 
                textAlign: 'center', 
                marginBottom: '50px',
                fontSize: '32px',
                fontWeight: '700'
              }}>
                特許情報
              </h2>
              
              {filteredPatents.map((patent) => (
                <div key={patent.id} style={{ marginBottom: '30px' }}>
                  <div style={{ 
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px',
                    padding: '30px'
                  }}>
                    <div className="row">
                      <div className="col-md-8">
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                          <h3 style={{ color: '#3b82f6', fontSize: '20px', marginRight: '15px', marginBottom: 0 }}>
                            {patent.title}
                          </h3>
                          <span style={{ 
                            background: patent.status === '登録済' ? '#10b981' : patent.status === '審査中' ? '#f59e0b' : '#3b82f6',
                            color: 'white',
                            padding: '4px 12px',
                            borderRadius: '20px',
                            fontSize: '12px'
                          }}>
                            {patent.status}
                          </span>
                        </div>
                        
                        <p style={{ color: '#94a3b8', fontSize: '14px', marginBottom: '15px' }}>
                          特許番号: {patent.patentNumber} | 出願日: {patent.applicationDate}
                          {patent.registrationDate !== '審査中' && ` | 登録日: ${patent.registrationDate}`}
                        </p>
                        
                        <p style={{ color: '#cbd5e1', lineHeight: '1.6', marginBottom: '15px' }}>
                          {patent.abstract}
                        </p>
                        
                        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                          <span style={{ color: '#94a3b8', fontSize: '14px' }}>
                            発明者: {patent.inventors.join(', ')}
                          </span>
                        </div>
                      </div>
                      
                      <div className="col-md-4">
                        <div style={{ 
                          background: 'rgba(59, 130, 246, 0.1)',
                          padding: '20px',
                          borderRadius: '8px',
                          textAlign: 'center'
                        }}>
                          <div style={{ marginBottom: '15px' }}>
                            <div style={{ color: '#3b82f6', fontSize: '24px', fontWeight: '600' }}>
                              {patent.claims}
                            </div>
                            <div style={{ color: '#94a3b8', fontSize: '14px' }}>請求項数</div>
                          </div>
                          <div style={{ marginBottom: '15px' }}>
                            <span style={{ 
                              background: patent.priority === '高' ? '#dc2626' : '#f59e0b',
                              color: 'white',
                              padding: '4px 12px',
                              borderRadius: '20px',
                              fontSize: '12px'
                            }}>
                              優先度: {patent.priority}
                            </span>
                          </div>
                          <button 
                            className="btn btn-custom btn-sm"
                            style={{ width: '100%' }}
                            onClick={() => window.open(`/patents/${patent.id}.pdf`, '_blank')}
                          >
                            詳細を見る
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 論文一覧 */}
      <section style={{ padding: '60px 0', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 style={{ 
                color: '#f1f5f9', 
                textAlign: 'center', 
                marginBottom: '50px',
                fontSize: '32px',
                fontWeight: '700'
              }}>
                研究論文
              </h2>
              
              {filteredPapers.map((paper) => (
                <div key={paper.id} style={{ marginBottom: '30px' }}>
                  <div style={{ 
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px',
                    padding: '30px'
                  }}>
                    <div className="row">
                      <div className="col-md-8">
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px', flexWrap: 'wrap', gap: '10px' }}>
                          <h3 style={{ color: '#3b82f6', fontSize: '18px', marginBottom: 0 }}>
                            {paper.title}
                          </h3>
                          {paper.openAccess && (
                            <span style={{ 
                              background: '#10b981',
                              color: 'white',
                              padding: '2px 8px',
                              borderRadius: '12px',
                              fontSize: '10px'
                            }}>
                              Open Access
                            </span>
                          )}
                        </div>
                        
                        <p style={{ color: '#94a3b8', fontSize: '14px', marginBottom: '15px' }}>
                          {paper.journal} ({paper.year}) | Impact Factor: {paper.impactFactor} | 
                          引用数: {paper.citations} | DOI: {paper.doi}
                        </p>
                        
                        <p style={{ color: '#cbd5e1', lineHeight: '1.6', marginBottom: '15px' }}>
                          {paper.abstract}
                        </p>
                        
                        <p style={{ color: '#94a3b8', fontSize: '14px' }}>
                          著者: {paper.authors.join(', ')}
                        </p>
                      </div>
                      
                      <div className="col-md-4">
                        <div style={{ 
                          background: 'rgba(16, 185, 129, 0.1)',
                          padding: '20px',
                          borderRadius: '8px',
                          textAlign: 'center'
                        }}>
                          <div style={{ marginBottom: '15px' }}>
                            <div style={{ color: '#10b981', fontSize: '24px', fontWeight: '600' }}>
                              {paper.citations}
                            </div>
                            <div style={{ color: '#94a3b8', fontSize: '14px' }}>引用数</div>
                          </div>
                          <div style={{ marginBottom: '15px' }}>
                            <div style={{ color: '#10b981', fontSize: '16px', fontWeight: '600' }}>
                              {paper.impactFactor}
                            </div>
                            <div style={{ color: '#94a3b8', fontSize: '14px' }}>Impact Factor</div>
                          </div>
                          <button 
                            className="btn btn-outline btn-sm"
                            style={{ 
                              width: '100%',
                              border: '1px solid #10b981',
                              color: '#10b981'
                            }}
                            onClick={() => window.open(`https://doi.org/${paper.doi}`, '_blank')}
                          >
                            論文を読む
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 研究成果の影響 */}
      <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 style={{ 
                color: '#f1f5f9', 
                textAlign: 'center', 
                marginBottom: '50px',
                fontSize: '32px',
                fontWeight: '700'
              }}>
                研究成果の影響
              </h2>
              
              <div className="row">
                <div className="col-md-3" style={{ textAlign: 'center', marginBottom: '30px' }}>
                  <div style={{ 
                    background: 'rgba(59, 130, 246, 0.1)',
                    padding: '30px',
                    borderRadius: '12px'
                  }}>
                    <div style={{ color: '#3b82f6', fontSize: '36px', fontWeight: '700', marginBottom: '10px' }}>
                      5
                    </div>
                    <div style={{ color: '#cbd5e1' }}>トップジャーナル<br />掲載論文</div>
                  </div>
                </div>
                <div className="col-md-3" style={{ textAlign: 'center', marginBottom: '30px' }}>
                  <div style={{ 
                    background: 'rgba(16, 185, 129, 0.1)',
                    padding: '30px',
                    borderRadius: '12px'
                  }}>
                    <div style={{ color: '#10b981', fontSize: '36px', fontWeight: '700', marginBottom: '10px' }}>
                      12
                    </div>
                    <div style={{ color: '#cbd5e1' }}>国際会議<br />発表件数</div>
                  </div>
                </div>
                <div className="col-md-3" style={{ textAlign: 'center', marginBottom: '30px' }}>
                  <div style={{ 
                    background: 'rgba(245, 158, 11, 0.1)',
                    padding: '30px',
                    borderRadius: '12px'
                  }}>
                    <div style={{ color: '#f59e0b', fontSize: '36px', fontWeight: '700', marginBottom: '10px' }}>
                      3
                    </div>
                    <div style={{ color: '#cbd5e1' }}>学会賞<br />受賞</div>
                  </div>
                </div>
                <div className="col-md-3" style={{ textAlign: 'center', marginBottom: '30px' }}>
                  <div style={{ 
                    background: 'rgba(239, 68, 68, 0.1)',
                    padding: '30px',
                    borderRadius: '12px'
                  }}>
                    <div style={{ color: '#ef4444', fontSize: '36px', fontWeight: '700', marginBottom: '10px' }}>
                      50+
                    </div>
                    <div style={{ color: '#cbd5e1' }}>共同研究<br />機関数</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ 
        padding: '80px 0',
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #3b82f6 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h2 style={{ color: 'white', marginBottom: '20px', fontSize: '32px' }}>
                技術提携・共同研究のご相談
              </h2>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', marginBottom: '30px', fontSize: '18px' }}>
                当社の知的財産を活用した技術提携や<br />
                共同研究プロジェクトについてご相談ください
              </p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
                <a href="/contact/partnership" className="btn btn-custom btn-lg" style={{ 
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: '2px solid white',
                  color: 'white'
                }}>
                  技術提携を相談
                </a>
                <a href="/resources/technical-docs" className="btn btn-custom btn-lg" style={{ 
                  background: 'white',
                  color: '#1e40af',
                  border: '2px solid white'
                }}>
                  技術資料をダウンロード
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default TechnologyPatentsPage; 